module.exports = __webpack_public_path__ + "static/media/zoom-in.3b8e5218.webp";